import React from 'react'

import background from './../UI/loading/background.webp'

import generalParticulares from "./../assets/recorridoComerciales/General_01.webp"
import generalComerciales from "./../assets/recorridoParticulares/General_01.webp"

import Loading from './Ingreso/Loading.component'
import LoadingMobile from './Ingreso/LoadingMobile.component'
import Tutorial from './Ingreso/Tutorial.component'
import Welcome from './Ingreso/welcome.component'
import WelcomeMobile from './Ingreso/welcomeMobile.component'

import MobileCheck from './mobileCheck'

interface Props{}

interface State{
    isMobile: boolean,
    changeRotation: boolean,
    isLoading: boolean,
    isIntroShowed: boolean,
    loadedImages: number,
    isTuto: boolean
} 

interface Ingreso{
    images: any
}

class Ingreso extends React.Component<Props, State>{

    constructor(props: Props){
        super(props);
        this.state = {
            isMobile: true,
            changeRotation: false,
            isLoading: true,
            isIntroShowed: false,
            loadedImages: 0,
            isTuto: false
        }
    }

    componentDidMount(){

        this.images = [
            generalParticulares,
            generalComerciales,
        ]

        if(this.images){
            this.images.forEach((src: any) => {
                new Promise((resolve, reject) => {
                    
                    const img = new Image()
                    img.src = src
                    img.onload = (event) => {
                        this.setState({
                            loadedImages: this.state.loadedImages + 2
                        }, () => {
                            console.log(this.state.loadedImages)
                            if(this.state.loadedImages === this.images.length){
                                this.setState({
                                    isLoading: false,
                                    isIntroShowed: true
                                })
                            }
                        })
                        
                    }
                    img.onerror = (err) => {
                        reject()
                    }
                })
            })
        }

        const mobile = MobileCheck() && (window.innerHeight > window.innerWidth)
        this.setState({isMobile: mobile})
        window.addEventListener('resize', this.update)

        
    }

    update = () => {
        const mobile = /*MobileCheck() &&*/ (window.innerHeight > window.innerWidth)
        this.setState({isMobile: mobile})
        window.addEventListener('resize', this.update)
    }


    handleHideIntroScreen = () => {
        this.setState({
            isIntroShowed: false
        })
    }

    handleShowTuto = () => {
        this.setState({
            isTuto: !this.state.isTuto
        })
    }

    render(): React.ReactNode {
        return(
            <div className='ingreso-main-screen'>
                <img className='background-image' src={background}/>
                <div className='background-container'/>
                {
                    !this.state.isMobile ?
                    <div className='ingreso-page'>
                        <Loading
                            isLoading = { this.state.isLoading }
                            ArrayLength = {this.images ? this.images.length: 0}
                            currentImagesDownloaded = {this.state.loadedImages}
                        />
                        <Welcome
                            isIntroShowed = {this.state.isIntroShowed}
                            handleOpenTutorialVideo = {this.handleShowTuto}
                        />
                        <Tutorial 
                            isTuto = {this.state.isTuto}
                            handleOpenTutorialVideo = {this.handleShowTuto}
                        />
                    </div>:<div className='ingreso-page-mobile'>
                        <LoadingMobile
                            isLoading = { this.state.isLoading }
                            ArrayLength = {this.images ? this.images.length: 0}
                            currentImagesDownloaded = {this.state.loadedImages}
                        />
                        <WelcomeMobile
                            isIntroShowed = {this.state.isIntroShowed}
                            handleOpenTutorialVideo = {this.handleShowTuto}
                        />
                        <Tutorial 
                            isTuto = {this.state.isTuto}
                            handleOpenTutorialVideo = {this.handleShowTuto}
                        />
                    </div>
                }
            </div>
        )
    }
}

export default Ingreso